import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MailCheck, RefreshCw } from 'lucide-react';
interface EmailVerificationProps {
  email: string;
  onGoBack: () => void;
  onContinue: () => void;
}
export function EmailVerification({
  email,
  onGoBack,
  onContinue
}: EmailVerificationProps) {
  const [resent, setResent] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="text-center" data-id="element-436">
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 md:p-12" data-id="element-437">
        <div className="w-20 h-20 bg-brand-navy/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-438">
          <MailCheck size={40} className="text-brand-navy" data-id="element-439" />
        </div>

        <h1 className="text-2xl md:text-3xl font-bold text-brand-navy mb-3" data-id="element-440">
          Check your email
        </h1>
        <p className="text-brand-muted mb-2" data-id="element-441">
          We sent a verification link to{' '}
          <span className="font-semibold text-brand-dark" data-id="element-442">
            {email || 'your email'}
          </span>
          .
        </p>
        <p className="text-brand-muted mb-8" data-id="element-443">
          Click the link to continue signing in.
        </p>

        {/* Prototype-only: simulate clicking the email link */}
        <button onClick={onContinue} className="w-full sm:w-auto bg-brand-navy hover:bg-blue-900 text-white px-6 py-3 rounded-lg font-semibold transition-colors mb-6" data-id="element-444">
          I clicked the link
        </button>

        <div className="space-y-3" data-id="element-445">
          <button onClick={() => setResent(true)} disabled={resent} className="inline-flex items-center gap-2 text-sm font-semibold text-brand-navy hover:text-brand-red transition-colors disabled:text-brand-muted disabled:cursor-default" data-id="element-446">
            <RefreshCw size={14} className={resent ? '' : ''} data-id="element-447" />
            {resent ? 'Email resent' : 'Resend email'}
          </button>
          <div data-id="element-448">
            <button onClick={onGoBack} className="text-xs text-brand-muted hover:text-brand-navy transition-colors" data-id="element-449">
              Wrong email? Go back
            </button>
          </div>
        </div>
      </div>

      <p className="text-center text-sm text-brand-muted mt-6" data-id="element-450">
        Still no email after a minute? Check your spam folder or{' '}
        <a href="tel:888-765-3854" className="text-brand-navy font-semibold hover:text-brand-red transition-colors" data-id="element-451">
          call us
        </a>
        .
      </p>
    </motion.div>;
}